export const readBlobAsDataUrl = (blob: Blob): Promise<string> =>
  new Promise<string>((resolve, reject) => {
    const reader: FileReader = new FileReader();

    reader.onload = (): void => resolve(String(reader.result));
    reader.onerror = (): void =>
      reject(reader.error ?? new Error("Falha ao ler a imagem"));

    reader.readAsDataURL(blob);
  });
